var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "no-click-animation": "",
      "overlay-color": "rgba(39, 50, 64)",
      "overlay-opacity": "0.6",
      "fullscreen": _vm.$vuetify.breakpoint.xs ? true : false,
      "persistent": "",
      "width": "500",
      "transition": false
    },
    model: {
      value: _vm.phoneDialog,
      callback: function callback($$v) {
        _vm.phoneDialog = $$v;
      },
      expression: "phoneDialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_vm.mandatory ? _c('span', [_vm._v(_vm._s(_vm.$t('packs.almostDone')))]) : _vm._e(), _c('v-spacer'), !_vm.mandatory ? _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function click($event) {
        _vm.phoneDialog = false;
      }
    }
  }, [!_vm.mandatory ? _c('v-icon', [_vm._v(" mdi-close ")]) : _vm._e()], 1) : _vm._e()], 1), _c('v-card-text', [_c('v-form', [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "id": "phone",
      "name": "phone",
      "prefix": "+",
      "label": _vm.$t('profile.phone'),
      "error-messages": _vm.phoneError
    },
    on: {
      "blur": function blur($event) {
        return _vm.$v.phone.$touch();
      }
    },
    scopedSlots: _vm._u([{
      key: "append",
      fn: function fn() {
        return [_c('v-tooltip', {
          attrs: {
            "top": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function fn(_ref) {
              var on = _ref.on;
              return [_c('small', _vm._g({}, on), [_vm._v(_vm._s(_vm.$t('profile.phoneWhy')))])];
            }
          }])
        }, [_vm._v(" " + _vm._s(_vm.$t('profile.phoneTooltip')) + " ")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.phone,
      callback: function callback($$v) {
        _vm.phone = typeof $$v === 'string' ? $$v.trim() : $$v;
      },
      expression: "phone"
    }
  })], 1), _c('v-flex', {
    attrs: {
      "mt-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "id": "support-verification-code",
      "name": "support-verification-code",
      "label": _vm.$t('profile.supportCode'),
      "placeholder": _vm.$t('profile.supportCodePlaceholder'),
      "error-messages": _vm.codeError,
      "type": _vm.showCode ? 'text' : 'password'
    },
    on: {
      "input": function input($event) {
        return _vm.$v.support_verification_code.$touch();
      },
      "blur": function blur($event) {
        return _vm.$v.support_verification_code.$touch();
      }
    },
    scopedSlots: _vm._u([{
      key: "append",
      fn: function fn() {
        return [_c('v-icon', {
          staticStyle: {
            "margin-right": "4px"
          },
          on: {
            "click": function click($event) {
              _vm.showCode = !_vm.showCode;
            }
          }
        }, [_vm._v(" " + _vm._s(_vm.showCode ? 'mdi-eye' : 'mdi-eye-off') + " ")]), _c('v-tooltip', {
          attrs: {
            "top": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function fn(_ref2) {
              var on = _ref2.on;
              return [_c('v-icon', _vm._g({}, on), [_vm._v(" mdi-information-outline ")])];
            }
          }])
        }, [_vm._v(" " + _vm._s(_vm.$t('profile.supportCodeHint')) + " ")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.support_verification_code,
      callback: function callback($$v) {
        _vm.support_verification_code = typeof $$v === 'string' ? $$v.trim() : $$v;
      },
      expression: "support_verification_code"
    }
  })], 1)], 1)], 1)], 1), _c('v-divider'), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "disabled": _vm.loading,
      "loading": _vm.loading
    },
    on: {
      "click": function click($event) {
        return _vm.save();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('globals.saveButton')) + " ")])], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }